import { Navigate, createFileRoute } from "@tanstack/react-router";

import { useCmmdForgeRuntimeListSnapshot } from "../cmmd/cmmdForgeRuntimeListResource";
import { FirstAccountSetupController } from "../components/onboarding/FirstAccountSetupController";
import { usePrimaryEnvironmentDescriptor } from "../environments/primary";
import { useCmmdForgeAccountPreferences } from "../cmmd/forgeAccountPreferences";
import {
  resolveFirstAccountSetupState,
  shouldUseCmmdFirstAccountSetupState,
} from "../lib/firstAccountSetup";
import { useServerSettings } from "../rpc/serverState";
import { shouldLeaveFirstAccountSetup } from "./setup.logic";

export const Route = createFileRoute("/setup")({
  component: SetupRouteView,
});

export function SetupRouteView() {
  const primaryEnvironmentDescriptor = usePrimaryEnvironmentDescriptor();
  const serverSetupState = useServerSettings().firstAccountSetup;
  const useCmmdSetupState = primaryEnvironmentDescriptor
    ? shouldUseCmmdFirstAccountSetupState(primaryEnvironmentDescriptor)
    : false;
  const cmmdAccountPreferences = useCmmdForgeAccountPreferences(useCmmdSetupState);
  // Same live catalog useFirstAccountSetupRedirect reads, so the two routes
  // agree on whether a cloud Environment exists before either one navigates.
  const cloudCatalog = useCmmdForgeRuntimeListSnapshot({ enabled: useCmmdSetupState });
  if (useCmmdSetupState && cmmdAccountPreferences.isError) {
    throw cmmdAccountPreferences.error;
  }
  const setupState = resolveFirstAccountSetupState({
    useCmmdState: useCmmdSetupState,
    cmmdState: cmmdAccountPreferences.data?.firstAccountSetup ?? null,
    serverState: serverSetupState,
  });

  if (setupState === null) {
    return null;
  }

  if (
    shouldLeaveFirstAccountSetup({
      setupState,
      useCmmdSetupState,
      cloudCatalog: {
        isLoading: cloudCatalog.isLoading,
        hasEnvironment: cloudCatalog.environments.length > 0,
      },
    })
  ) {
    return <Navigate to="/new" replace />;
  }

  return <FirstAccountSetupController />;
}
